// extracted by mini-css-extract-plugin
module.exports = {"div_general_reviewRender":"ReviewRender_div_general_reviewRender__2-pIJ","textarea_reviewRender":"ReviewRender_textarea_reviewRender__jpt5B"};